






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class extends Vue {
	@Prop()
	iconClass!: string

	@Prop()
	className?: string | ''

	get iconName() {
		return `#icon-${this.iconClass}`
	}

	get svgClass() {
		if (this.className) {
			return 'svg-icon ' + this.className
		} else {
			return 'svg-icon'
		}
	}
}
